/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

import * as Jed from 'jed';
import * as translation_ar from '../locales/ar.po.json';

const locales = {
  'AR': translation_ar,
  'EN': {}
};

let jed = new Jed({});
let currentLocale;

// tslint:disable-next-line:variable-name
function setLocale(_locale = 'AR') {
  const locale = _locale.toUpperCase().substr(0, 2);
  currentLocale = locales[locale] ? locale : 'AR';
  jed = new Jed(locales[currentLocale]);
  i18n = jed;
}

let i18n = {
  gettext: (key) => jed.gettext(key),
  pgettext: (context, key) => jed.pgettext(context, key),
  // tslint:disable-next-line:object-literal-sort-keys
  npgettext: (context, one, many, count) => jed.npgettext(context, one, many, count),
  sprintf: jed.sprintf.bind(jed)
};

export default i18n;
export {
  i18n,
  currentLocale,
  setLocale
};



// WEBPACK FOOTER //
// ./src/app/getText.ts